"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _large3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.HeroButton = exports.HeadlineImage = exports.HeroBanner = exports.HeroSubTitle = exports.HeroHeadline = exports.HeroColumn = exports.TextOnlyOverlay = exports.Overlay = exports.Wrapper = exports.MediaWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _Button = _interopRequireDefault(require("../Button"));

var _Media = _interopRequireDefault(require("../Media"));

var _Layout = require("../Layout");

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Typography = require("../Typography");

var MediaWrapper = (0, _styled.default)(_Media.default)(function (_ref) {
  var _large;

  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      hero = _ref$theme.hero;
  return (0, _styledSystem.variant)({
    variants: {
      large: (_large = {
        overflow: 'hidden',
        height: '35.8rem'
      }, _defineProperty(_large, _mediaQueries.default.large, {
        height: '46.2rem'
      }), _defineProperty(_large, _mediaQueries.default.xlarge, {
        height: '56rem'
      }), _defineProperty(_large, "borderBottom", "".concat(hero.wrapBorder.width, " ").concat(hero.wrapBorder.style, " ").concat(colors[hero.wrapBorder.color])), _large),
      standard: {
        overflow: 'hidden',
        height: '25rem',
        borderBottom: "".concat(hero.wrapBorder.width, " ").concat(hero.wrapBorder.style, " ").concat(colors[hero.wrapBorder.color])
      },
      article: _defineProperty({
        overflow: 'hidden',
        height: '33.6rem'
      }, _mediaQueries.default.xlarge, {
        height: '40rem'
      })
    }
  });
});
exports.MediaWrapper = MediaWrapper;
var Wrapper = (0, _styled.default)('div')(function (_ref2) {
  var _large2;

  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      hero = _ref2$theme.hero;
  return (0, _styledSystem.variant)({
    variants: {
      large: (_large2 = {
        overflow: 'hidden',
        height: '35.8rem'
      }, _defineProperty(_large2, _mediaQueries.default.large, {
        height: '46.2rem'
      }), _defineProperty(_large2, _mediaQueries.default.xlarge, {
        height: '56rem'
      }), _defineProperty(_large2, "borderBottom", "".concat(hero.wrapBorder.width, " ").concat(hero.wrapBorder.style, " ").concat(colors[hero.wrapBorder.color])), _large2),
      standard: {
        overflow: 'hidden',
        height: '25rem',
        borderBottom: "".concat(hero.wrapBorder.width, " ").concat(hero.wrapBorder.style, " ").concat(colors[hero.wrapBorder.color])
      },
      article: _defineProperty({
        overflow: 'hidden',
        height: '33.6rem'
      }, _mediaQueries.default.xlarge, {
        height: '40rem'
      })
    }
  });
});
exports.Wrapper = Wrapper;
var OverlayStyles = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center'
};
var Overlay = (0, _styled.default)('div')(function (_ref3) {
  var hero = _ref3.theme.hero;
  return _objectSpread(_objectSpread({}, OverlayStyles), {}, {
    alignItems: 'center',
    backgroundColor: hero.overlay
  });
});
exports.Overlay = Overlay;
var TextOnlyOverlay = (0, _styled.default)('div')(function (_ref4) {
  var hero = _ref4.theme.hero;
  return _objectSpread(_objectSpread({}, OverlayStyles), {}, {
    alignItems: hero.textOnlyAlignItems,
    backgroundColor: hero.overlay
  });
});
exports.TextOnlyOverlay = TextOnlyOverlay;
var HeroColumn = (0, _styled.default)(_Layout.Column)(function (_ref5) {
  var _objectSpread2;

  var hero = _ref5.theme.hero;
  var style = {
    display: 'flex',
    alignItems: hero.alignItems,
    textAlign: hero.alignItems,
    flexDirection: 'column'
  };
  return (0, _styledSystem.variant)({
    variants: {
      standard: _objectSpread(_objectSpread({}, style), {}, (_objectSpread2 = {
        padding: hero.standardPaddingMobile
      }, _defineProperty(_objectSpread2, _mediaQueries.default.small, {
        padding: hero.standardPaddingSmall
      }), _defineProperty(_objectSpread2, _mediaQueries.default.xlarge, {
        padding: hero.standardPaddingXLarge
      }), _objectSpread2)),
      large: _objectSpread(_objectSpread({}, style), {}, {
        alignItems: hero.largeAlignItems,
        textAlign: hero.largeAlignItems
      })
    }
  });
});
exports.HeroColumn = HeroColumn;
var HeroHeadline = (0, _styled.default)(_Typography.HeroTitle)( // eslint-disable-next-line no-shadow
function (_ref6) {
  var _ref6$theme = _ref6.theme,
      hero = _ref6$theme.hero,
      colors = _ref6$theme.colors,
      textColor = _ref6.textColor,
      variant = _ref6.variant;
  var textShadow = textColor === 'standard' ? hero.textShadow : hero.textShadowInverted;

  if (variant === 'article') {
    textShadow = 'none';
  }

  var paddingBottom = variant === 'large' ? hero.paddingBottomOnLarge : '0';
  return {
    fontStyle: hero.fontStyle,
    fontWeight: hero.fontWeight,
    color: variant === 'article' ? colors[hero.textColorArticle] : colors[hero.textColor[textColor]],
    textTransform: hero.titleTransform,
    textShadow: textShadow,
    paddingBottom: paddingBottom,
    // IE fix
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      alignSelf: 'stretch'
    }
  };
});
exports.HeroHeadline = HeroHeadline;
var HeroSubTitle = (0, _styled.default)(_Typography.PageTitle)( // eslint-disable-next-line no-shadow
function (_ref7) {
  var _ref7$theme = _ref7.theme,
      hero = _ref7$theme.hero,
      colors = _ref7$theme.colors,
      textColor = _ref7.textColor,
      variant = _ref7.variant;
  var textShadow = textColor === 'standard' ? hero.textShadow : hero.textShadowInverted;

  if (variant === 'article') {
    textShadow = 'none';
  }

  var paddingBottom = variant === 'large' ? hero.paddingBottomOnLarge : '0';
  return {
    '&::before': {
      display: 'none'
    },
    fontStyle: hero.fontStyle,
    color: colors[hero.textColor[textColor]],
    textShadow: textShadow,
    paddingBottom: paddingBottom,
    // IE fix
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      alignSelf: 'stretch'
    }
  };
});
exports.HeroSubTitle = HeroSubTitle;
var HeroBanner = (0, _styled.default)('div')(_defineProperty({
  display: 'block',
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  zIndex: '2'
}, _mediaQueries.default.medium, {
  top: '1.5rem',
  right: '1.5rem'
}));
exports.HeroBanner = HeroBanner;
var HeadlineImage = (0, _styled.default)(_Media.default)((0, _styledSystem.variant)({
  variants: {
    standard: _defineProperty({
      height: 'auto',
      width: '100%',
      display: 'block',
      margin: '0 auto'
    }, _mediaQueries.default.medium, {
      width: '90%'
    }),
    large: (_large3 = {
      height: 'auto',
      width: '90%',
      display: 'block',
      margin: '0 auto'
    }, _defineProperty(_large3, _mediaQueries.default.medium, {
      width: '80%'
    }), _defineProperty(_large3, _mediaQueries.default.large, {
      width: '90%'
    }), _large3)
  }
}));
exports.HeadlineImage = HeadlineImage;
var HeroButton = (0, _styled.default)(_Button.default)(function (_ref9) {
  var hero = _ref9.theme.hero;
  return {
    boxShadow: hero.buttonBoxShadow,
    '&:active': {
      boxShadow: 'none'
    }
  };
});
exports.HeroButton = HeroButton;